export default {
    uploadEndPoint: 14
}
export const dateFormat = {
    TIME_SECOND: 'YYYY-MM-DD HH:mm:ss',
    TIME_MINUTE: 'YYYY-MM-DD HH:mm',
    TIME_HOUR: 'YYYY-MM-DD HH',

    DATE_DAY: 'YYYY-MM-DD',
    DATE_MONTH: 'YYYY-MM',
    DATE_YEAR: 'YYYY'
}
export const arealevel = {
    CHANNEL_LEVEL: 'channel_level', //渠道等级
    AREA_LEVEL: 'area_level', //城市类型
}
export const publish_status = {
    0: "未发布",
    1: "已发布",
};

// TODO 政策兑现
export const policy = {
    INTELLECTUALSUBSIDY_TYPE: 'intellectualsubsidy_type',    // 知识产权补贴 知识产权类别
    INTELLECTUALSUBSIDY_GET: 'intellectualsubsidy_get',     //知识产权补贴 取得形式
    INTELLECTUAL_AWARDCATEGORY: 'intellectual_awardcategory',    // 科技奖项补贴  获奖类别
    INTELLECTUAL_DISTRIBUTIONTYPE: 'intellectual_distributiontype',    // 区级创新券兑现  发放种类
    INTELLECTUAL_CORPTYPE: 'intellectual_corptype',    // 区级创新券兑现  奖励类企业类别
    INTELLECTUAL_PLATFORMLEVEL: 'intellectual_platformlevel',    // 科技研发类平台补贴  平台级别
    INTELLECTUAL_PLATFORMTYPE: 'intellectual_platformType',    // 科技研发类平台补贴  平台类别
}

export const company = {
    FIRSTADJUDICATOR: 'firstAdjudicator',//第一审批人
    PERSONSECONDINSTANCE: 'personSecondInstance',//第二审批人
    CONNECT_TYPE: 'connect_type', //沟通方式
    RESULT_STATUS: 'result_status', //沟通结果
    IF_SOUND_FILE: 'if_sound_file', //有无录音
    SIGN_SERVICE_TYPE: 'sign_service_type', //服务类型
    SIGN_SERVICE_STATUS: 'sign_service_status', //	签约服务状态
    SIGN_SERVICE_BATCH: 'sign_service_batch', //	签约服务批次
    SEX: 'sex', //	性别
    CUSTOMER_POST: 'customer_post', //	客户职务
    TRUE_FALSE: 'true_false', //	是否
    CONNECT_STATUS: 'connect_status', //	客户状态
    CUSTOMER_TYPE: 'customer_type', //	客户类型
    REGISTER_MONEY: 'register_money', //	注册资本
    INDUSTRY: 'industry', //	行业
    REVENUE_SCOPE: 'revenue_scope', //	营收范围
    REVENUE_RATING: 'revenue_rating', //	营收评级
    EMPLOYEE_SCOPE: 'employee_scope', //	人员规模
    CUSTOMER_SERVICETYPE: 'customer_serviceType', //	服务类别
    DECLARED_ITEMS: 'declared_items', //		已申报项目
    INTENDED_SERVICE: 'intended_Service', //		意向服务类型
    PAYCOST_BATCH: 'paycost_batch', //		缴费批次
    APPROVETYPE: 'approveType', //		审批类型
    APPROVESTATUS: 'approveStatus', //		审批状态
    BOOKING_STATUS: 'booking_status', //		预约状态
    TREATMENT_STATUS: 'treatment_status', //		处理状态
    CUSTOMER_STATUS: 'customer_status', //		客户状态
    SOURCE_CUSTOMERS: 'source_customers', //		客户来源

}

// TODO 科技金融
export const financeDict = {
    POSITION: 'position', //投资人职位
    INVESTMENTFIELD: 'investmentField', //投资领域
    INVESTMENTWAY: 'investmentWay', //投资方式
    ORGANIZATIONTYPE: 'organizationType', //机构类型
    GUARANTEE: 'guarantee', //担保方式
    LOANDEADLINE: 'loanDeadline', //贷款期限
    PAYMENTTYPE: 'paymentType', //还款方式
    LOANTYPE: 'loanType', //贷款类型
    CLASSROOM_TYPE: 'classRoom_type', //课程分类
    DOCKINGTYPE: 'dockingType', //对接类型
    ADUIT_STATUS: 'aduit_status', //审核状态
    PROJECTSTAGE: 'projectStage', //项目阶段
    ADVICERSTATUS: 'advicerStatus', //已读状态
    ADVISERTYPE: 'advisertype', //咨询类型
    INVEST_LIMIT: 'invest_limit', //投资额度
    NEEDTYPE:'needType' //需求类型
}

//TODO 创新创业
export const innovation = {
    DEMAND_TYPE: 'demand_type', //需求类型
    ISPUBLIC: 'isPublic', //是否公开
    INDUSTRY_TYPE: 'industry_type', //产业类型
    SERVICETYPE: 'servicetype', //机构类型
    LABORATORY_LEVEL: 'laboratory_level', //实验室级别
    NATURE: 'nature', //机构性质
    TECHNICAL_FIELD: 'technical_field', //技术领域
    PROJECT_TYPE: 'projectType', //行业类型
}
// TODO 知识产权
export const knowledge = {
    TRADE_MODE: 'tradeMode', //知识产权交易方式
    PRICE_TYPE: 'priceType', //价格类型
}

// TODO 服务机构
export const COMMON_VARIABLE = {
    approvalState: {
        "0": "未审核",
        "1": "审核成功",
        "2": "审核失败"
    },
}

// TODO 科技人才
export const education = {
    WORK_TYPE: 'work_type', // 工作类型
    WORK_EXPERIENCE: 'work_experience', // 工作经验
    SALARY: 'salary', //薪资
    RESEARCH_FIELD: 'research_field', // 行业类型
    EDUCATION_BACKGROUND: 'education_background', // 学历
    FRINGE_BENEFITS: 'fringe_benefits',   // 福利待遇
    MAJOR: 'education_major',    // 所属专业
    HOPE_SHOW:'hope_show',  // 期望展示效果
    HOPE_JOB: 'hope_job',   //  期望职位
    WORK_STATUS: 'work_status',   //  工作状态
    TALENTTITLE: 'talentTitle',   //  职称
}

// TODO 刻章服务
export const SealService = {
    TYPESEAL: 'TypeSeal', // 刻章类型
    STUFFSEAL: 'stuffSeal', // 刻章材料
}